/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.17.1
 * @since 1.1.0
 */

import { colors } from '../../../../../theme';
import {
    EChartDataKeyEnum,
    IChartAnimateConfiguration, IChartDataInput, IChartGridConfiguration, IChartLegendConfiguration,
    IChartPaddingConfiguration,
    IChartScaleConfiguration,
    IChartTooltipConfiguration,
    IChartTooltipWrapperTemplate,
    TChartType,
} from '../../chartTypes';
import { ChartDynamicTooltipWrapperTemplate } from './ChartDynamicTooltip';


export const ChartDynamicType: TChartType = 'line';
export const ChartDynamicHeight = 476;
export const ChartDynamicAnimate: IChartAnimateConfiguration = {};
export const ChartDynamicPadding: IChartPaddingConfiguration = {
    bottom: 10,
    left: 60,
    right: 2,
    top: 24,
};

export const ChartDynamicScaleConfiguration: IChartScaleConfiguration = {
    [EChartDataKeyEnum.x]: {
        range: [0, 1],
    },
    [EChartDataKeyEnum.y]: {
        min: 0,
    },
};

export const ChartDynamicTooltipConfiguration: IChartTooltipConfiguration = {
    isNotFiltered: true,
    render: (props: IChartTooltipWrapperTemplate) => ChartDynamicTooltipWrapperTemplate(props),
    crosshair: {
        style: {
            lineWidth: 1,
            stroke: colors.borderColorNormal,
        },
        type: 'y',
    },
};

export const ChartDynamicLegendConfiguration: IChartLegendConfiguration = {
    className: 'chart-legend_dynamic',
    dataName: 'chartLegendDynamic',
    legendRow: 3,
    withSubtitle: true,
};

export const ChartDynamicGridConfiguration: IChartGridConfiguration = {
    x: {
        lineStyle: {
            stroke: colors.borderColorDisabled,
            lineWidth: 1,
            lineDash: [],
        },
        type: 'line',
    },
    y: {
        lineStyle: {
            lineDash: [],
            lineWidth: 1,
            stroke: colors.borderColorDisabled,
        },
        type: 'line',
    },
};

export const ChartDynamicDataConfiguration = (item: IChartDataInput, account: string) => {
    const y = item[EChartDataKeyEnum.y][account];
    return ({
        [EChartDataKeyEnum.name]: item[EChartDataKeyEnum.x],
        [EChartDataKeyEnum.x]: account,
        [EChartDataKeyEnum.y]: y >= 0 ? y : 0,
    });
}
